<script>
	import { isMobile } from '../utilities/store';
  import LanguageCordNavigation from "./LanguageCordNavigation.svelte";
</script>

{#if !$isMobile }
 <LanguageCordNavigation/>
{/if}
